module.exports = __webpack_public_path__ + "static/kostka_mielona@1x-c70b2083a890f589a9ba411252928e1f.png";